import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';
import { TermPinModel } from './models/term_pin_model';
import { TermPinQuery } from './queries/term_pin_query';
import { TermPinServant } from './servants/term_pin_servant';

class TermPin {
  private isTermPinFeatureEnabled = false;
  private appointmentFeatureEnabled = false;
  private advisorText: string = '';

  constructor(
    private ngTermPinQuery: TermPinQuery,
    private ngTermPinModel: TermPinModel,
    private ngTermPinServant: TermPinServant,
    private appConfigModel: any
  ) {}

  $onInit() {
    this.isTermPinFeatureEnabled = this.ngTermPinServant.isTermPinFeatureEnabled();
    this.appointmentFeatureEnabled = this.appConfigModel.isFeatureEnabled('ssccampus-appointment_scheduling');
    this.advisorText = ` Contact your ${_4.toLower(
      _4.get(this.appConfigModel, 'model.member_configs.advisor_label', 'advisor')
    )}`;
  }

  onValueChanged(event: any) {
    this.updateTermPin(event.target.value);
  }

  updateTermPin(newTermPin: string = '') {
    const term_pin = this.ngTermPinModel.read().term_pin;
    if (!_4.isEqual(term_pin, newTermPin)) {
      const updatedTermPin = newTermPin;
      const newTermPinData = {
        term_pin,
        updatedTermPin,
        isPinUpdated: true
      };
      this.ngTermPinModel.clear().write(newTermPinData);
      this.ngTermPinQuery.run();
    }
  }
}

class TermPinComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {};
    this.controller = TermPin;
    this.templateUrl = 'capability-ng-scheduler/src/components/term_pin/term_pin.html';
  }
}
angular.module('capability-ng-scheduler').component('termPin', new TermPinComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/term_pin/term_pin.ts